import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import React from "react";

// Skeleton for horizontal bar chart
const ChartSkeleton = () => (
  <div className="animate-pulse h-[220px] sm:h-[280px] flex flex-col justify-between py-4">
    {[...Array(5)].map((_, i) => (
      <div key={i} className="flex items-center gap-3 sm:gap-4">
        <div className="h-3 sm:h-4 w-20 sm:w-24 bg-gray-200 rounded"></div>
        <div
          className="h-4 sm:h-5 bg-gray-200 rounded"
          style={{ width: `${Math.random() * 40 + 30}%` }}
        ></div>
      </div>
    ))}
  </div>
);

const BookingsTrendChart = ({ data, isLoading = false }) => {
  return (
    <div className="bg-white p-4 sm:p-6 shadow-sm rounded-xl">
      {/* Title */}
      <h2 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">
        Bookings Trend
      </h2>

      <div className="w-full h-[220px] sm:h-[280px]">
        {isLoading ? (
          <ChartSkeleton />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical"
              data={data}
              margin={{
                top: 10,
                right: 20,
                left: 20, // mobile friendly
                bottom: 10,
              }}
            >
              <defs>
                <linearGradient id="aquaGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#1FADC6" />
                  <stop offset="100%" stopColor="#00D1E0" />
                </linearGradient>
              </defs>

              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#F3F4F6"
                horizontal={false}
              />

              {/* Labels on left */}
              <YAxis
                dataKey="name"
                type="category"
                width={80} // 👈 mobile fix
                tick={{ fill: "#6B7280", fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />

              {/* Values along bottom */}
              <XAxis
                type="number"
                tick={{ fill: "#6B7280", fontSize: 11 }}
                axisLine={false}
                tickLine={false}
              />

              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  fontSize: "12px",
                }}
              />

              <Bar
                dataKey="value"
                fill="url(#aquaGradient)"
                radius={[6, 6, 6, 6]}
                barSize={14} // 👈 mobile friendly
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default BookingsTrendChart;
